module.exports = {
  // デバックモードかどうか
  is_debug: process.env.NODE_ENV === 'development',

  is_local: location.hostname === 'localhost',

  // スクリーンサイズ
  screen: {
    sp    : 480,
    tablet: 768
  },

  // WordPressのテーマディレクトリまでのパス
  theme_path: typeof THEME_PATH === 'undefined' ? '' : THEME_PATH,

  // WordPressのリクエスト送信先のパス
  ajax_url: typeof AJAX_URL === 'undefined' ? '' : AJAX_URL
};


// WEBPACK FOOTER //
// ./src/js/common/config.js